import { FC, ReactNode, RefObject } from 'react';
import { FormProvider } from 'react-hook-form';
import { useInvestmentForm } from '../hooks';
import { InvestmentFormContextProvider } from '../context';

interface InvestmentFormProps {
  children?: ReactNode;
  className?: HTMLFormElement['className'];
  useInvestmentFormReturn: ReturnType<typeof useInvestmentForm>;
  formRef?: RefObject<HTMLFormElement>;
}

/**
 * 
 * @deprecated Use ElementsForm from packages/elements/src/UI/components/ElementsForm.tsx in combination with
 * useCreateInvestmentForm from  packages/elements/src/Investment/hooks/useCreateInvestmentForm.ts
 * and useEditInvestmentForm from  packages/elements/src/Investment/hooks/useEditInvestmentForm.ts
 * instead
 */
export const InvestmentForm: FC<InvestmentFormProps> = ({
  children,
  className,
  useInvestmentFormReturn: { onSubmit, formMethods, investment, householdID },
  formRef,
}) => {
  return (
    <FormProvider {...formMethods}>
      <InvestmentFormContextProvider householdID={householdID} investment={investment}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)} ref={formRef}>
          {children}
        </form>
      </InvestmentFormContextProvider>
    </FormProvider>
  );
};
